import React from 'react';
import { Card, CardContent, CardTitle } from '../../components/ui/card';
import { Clock, Wrench, ShoppingBag, BookOpen, Award, User, CheckCircle } from 'lucide-react';

interface Activity {
  id: string;
  type: 'repair' | 'order' | 'course' | 'certificate' | 'profile' | 'payment';
  title: string;
  description: string;
  timestamp: string;
  status?: 'completed' | 'pending' | 'in-progress';
}

const mockActivities: Activity[] = [
  {
    id: '1',
    type: 'repair',
    title: 'iPhone 15 Pro Screen Replacement',
    description: 'Repair completed successfully',
    timestamp: '2 hours ago',
    status: 'completed',
  },
  {
    id: '2',
    type: 'order',
    title: 'Samsung Galaxy S24',
    description: 'Order #1002 is out for delivery',
    timestamp: '5 hours ago',
    status: 'pending',
  },
  {
    id: '3',
    type: 'course',
    title: 'Completed "Micro Soldering Essentials"',
    description: 'Certificate issued',
    timestamp: '1 day ago',
    status: 'completed',
  },
  {
    id: '4',
    type: 'certificate',
    title: 'Earned "Phone Repair Masterclass" Certificate',
    description: 'Download your certificate',
    timestamp: '3 days ago',
    status: 'completed',
  },
  {
    id: '5',
    type: 'profile',
    title: 'Profile Updated',
    description: 'Phone number changed',
    timestamp: '5 days ago',
  },
];

const iconMap = {
  repair: Wrench,
  order: ShoppingBag,
  course: BookOpen,
  certificate: Award,
  profile: User,
  payment: CheckCircle,
};

const statusColors = {
  completed: 'text-green-500',
  pending: 'text-yellow-500',
  'in-progress': 'text-blue-500',
};

export const ActivityTimeline: React.FC = () => {
  return (
    <Card>
      <CardTitle className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Clock className="h-5 w-5 text-primary" />
          <span>Activity Timeline</span>
        </div>
      </CardTitle>
      <CardContent>
        <div className="space-y-4">
          {mockActivities.map((activity) => {
            const Icon = iconMap[activity.type] || Clock;
            return (
              <div
                key={activity.id}
                className="flex items-start space-x-3 border-b border-[rgb(var(--border))] pb-4 last:border-0 last:pb-0"
              >
                <div className="rounded-full bg-primary/10 p-2">
                  <Icon className="h-4 w-4 text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2">
                    <p className="text-sm font-medium text-[rgb(var(--foreground))]">
                      {activity.title}
                    </p>
                    {activity.status && (
                      <span className={`text-xs ${statusColors[activity.status]}`}>
                        {activity.status.replace('-', ' ')}
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-[rgb(var(--light-secondary))]">
                    {activity.description}
                  </p>
                  <p className="text-xs text-[rgb(var(--light-secondary))]">
                    {activity.timestamp}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};